import { Icon } from '@studio/design-system/icon';
import { Content, List, Tabs as Root, Trigger } from '@studio/design-system/tabs';
import type { ReactElement } from 'react';
import { Column, Exhibit } from './styled.jsx';

/** `<Tabs>` exhibit. */
export const Tabs = (): ReactElement => (
  <Exhibit title='Tabs'>
    <Column className='p-0'>
      <Root defaultValue='alpha'>
        <List>
          <Trigger value='alpha'>
            <Icon icon='source' />
            Video (6)
          </Trigger>

          <Trigger value='beta'>
            <Icon icon='audio' />
            Video (2)
          </Trigger>

          <Trigger disabled value='gamma'>
            Disabled
          </Trigger>
        </List>

        <div className='p-24'>
          <Content value='alpha'>This is video tab.</Content>
          <Content value='beta'>This is audio tab.</Content>
          <Content value='gamma'>You should not see this.</Content>
        </div>
      </Root>
    </Column>
  </Exhibit>
);
